import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button
} from '@chakra-ui/react';

import { ChevronDownIcon } from '@chakra-ui/icons';

import Const from '../Constants';

import { useState, useEffect } from 'react';

const HighLowSelector = ({ value, onChange }) => {
  const list = [Const.sHigh, Const.sLow];
  const [currentValue, setCurrentValue] = useState(value ? value : Const.sLow);

  useEffect(() => {
    setCurrentValue(value ? value : Const.sLow);
  }, [value]);

  return (
    <Menu>
      <MenuButton
        as={Button}
        rightIcon={<ChevronDownIcon />}
        width="40"
        size={Const.SM}
        bg={currentValue === Const.sHigh ? Const.ActiveLightColor : Const.DoneLightColor }
        color={Const.White}
        borderRadius="md"
        border="1px solid"
        borderColor={Const.Gray100}
        textAlign="left"
        _hover={{ bg: Const.Gray69 }}
        _focus={{ boxShadow: 'none' }}
        _expanded={{ bg: currentValue === Const.sHigh ? Const.ActiveLightColor : Const.DoneLightColor }}
      >
        {currentValue}
      </MenuButton>
      <MenuList borderRadius={0} bg='transparent' padding={0} margin={0} borderColor={Const.Gray180}>
        {list.map((item) => (
          <MenuItem
            key={item}
            onClick={() => {
              setCurrentValue(item);

              onChange(item);
            }}
            bg={ item === Const.sHigh ? Const.ActiveLightColor : Const.DoneLightColor }
            _hover={{ bg: Const.Gray69 }}
            color={Const.White}
            fontSize={Const.SM}
          >
            {item}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default HighLowSelector;
